import PropTypes from 'prop-types';
import { sortDirection } from '../../components/assignments/assignmentsPage/assignmentsList/AssignmentsConstants';

export const AssignmentModel = {
    assignmentId: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    productLogoUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    assignmentType: PropTypes.string.isRequired,
    dueDate: PropTypes.string,
    startDate: PropTypes.string,
    url: PropTypes.string
};

export const AssignmentSortModel = {
    columnName: PropTypes.string,
    direction: PropTypes.oneOf([sortDirection.ascending, sortDirection.descending])
};
